import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import onlineWebinarImage from '../../../assets/images/online webinar.png';

const certificates = [
  {
    title: 'Full Stack Development 2026',
    issuedBy: 'Guvi - HCL',
    date: '18 December 2025',
    image: onlineWebinarImage,
    link: 'https://drive.google.com/file/d/1VduodjLo-c4vYu-3zh_4A1FwXGZQhP1A/view?usp=sharing'
  }
];

const OnlineWebinarCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Online Webinar"
      certificates={certificates}
    />
  );
};

export default OnlineWebinarCertificates;
